/**
 * PATH: apps/quote/src/components/builder/panels/takeoff-assist/CoverageGapCard.tsx
 * PURPOSE: Coverage gap card for missing scope items
 */

import { AlertTriangle, Plus } from 'lucide-react'
import type { TakeoffCoverageGap } from '@/lib/quoteApi'

export default function CoverageGapCard({
  gap, onAdd,
}: {
  gap: TakeoffCoverageGap; onAdd: () => void
}) {
  return (
    <div className="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-lg border border-amber-200 dark:border-amber-800/50">
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-4 h-4 text-amber-500 shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-slate-900 dark:text-white line-clamp-2">
            {gap.description}
          </p>
          <p className="text-xs text-slate-500 mt-0.5">{gap.message}</p>
          <div className="flex items-center justify-between mt-2">
            <span className="text-[10px] text-amber-600 dark:text-amber-400">
              {gap.confidence}% confidence
            </span>
            <button onClick={onAdd} className="text-xs text-blue-600 hover:text-blue-700 font-medium flex items-center gap-1">
              <Plus className="w-3 h-3" /> Add item
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
